"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NUMBER_INPUT_MIN_VALUE = exports.CounterInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("b2b-components/theme/components/Button");
var _common = require("b2b-components/theme/components/Form/common");
var _TextInput = require("b2b-components/theme/components/Form/TextInput");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
var _Error = require("../common/Error");
require("./CounterInput.scss");
var NUMBER_INPUT_MIN_VALUE = 1;
exports.NUMBER_INPUT_MIN_VALUE = NUMBER_INPUT_MIN_VALUE;
var CounterInput = function CounterInput(_ref) {
  var className = _ref.className,
    hasFocus = _ref.hasFocus,
    isDecreaseDisabled = _ref.isDecreaseDisabled,
    isIncreaseDisabled = _ref.isIncreaseDisabled,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onDecreaseClick = _ref.onDecreaseClick,
    onFocus = _ref.onFocus,
    onIncreaseClick = _ref.onIncreaseClick,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? null : _ref$error,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? _common.STYLE_TYPE.outlined : _ref$styleType,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? NUMBER_INPUT_MIN_VALUE : _ref$value;
  var rootClassName = (0, _classnames["default"])('cds-CounterInput', "cds-CounterInput--".concat((0, _upperCaseFirst.upperCaseFirst)(styleType)), {
    'cds-Form-Input--Error': error,
    'cds-CounterInput--Disabled': isDisabled
  }, className);
  var quantityClassName = (0, _classnames["default"])('cds-CounterInput-Quantity', {
    'cds-CounterInput-Quantity--Expanded': hasFocus
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    className: "cds-CounterInput-Button",
    isDisabled: isDisabled || isDecreaseDisabled,
    onClick: onDecreaseClick
  }, "\u2212"), /*#__PURE__*/_react["default"].createElement(_TextInput.TextInput, {
    className: quantityClassName,
    isDisabled: isDisabled,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    styleType: styleType,
    value: value
  }), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    className: "cds-CounterInput-Button",
    isDisabled: isDisabled || isIncreaseDisabled,
    onClick: onIncreaseClick
  }, "+")), error && /*#__PURE__*/_react["default"].createElement(_Error.Error, null, error));
};
exports.CounterInput = CounterInput;